import { c as __rest, _ as __assign, b as __spreadArray } from './tslib.es6-86dc5b0c.js';
import { jsx } from 'react/jsx-runtime';
import { JsonForms as JsonForms$1 } from '@jsonforms/react';
import { J as JsonFormsAnyOfControl, j as jsonFormsAnyOfControlTester } from './JsonFormsAnyOfControl-b00f4c98.js';
import { J as JsonFormsNullControl, j as jsonFormsNullControlTester } from './JsonFormsNullControl-fe068dd5.js';
import { J as JsonFormsOneOfEnumControl, j as jsonFormsOneOfEnumControlTester } from './JsonFormsOneOfEnumControl-3c0be13a.js';
import { J as JsonFormsStringControl, j as jsonFormsStringControlTester } from './JsonFormsStringControl-a7b2cd57.js';
import { J as JsonFormsHorizontalLayout, j as jsonFormsHorizontalLayoutTester } from './JsonFormsHorizontalLayout-6ad19365.js';
import { J as JsonFormsVerticalLayout, j as jsonFormsVerticalLayoutTester } from './JsonFormsVerticalLayout-32077a8c.js';
import { J as JsonFormsGroupLayout, a as JsonFormsGroupLayoutTester } from './JsonFormsGroupLayout-bd447ec3.js';
import { J as JsonFormsBooleanControl, j as jsonFormsBooleanControlTester } from './JsonFormsBooleanControl-1eeeff81.js';

var JsonForms = function (_a) {
    var _b = _a.renderers, renderers = _b === void 0 ? [] : _b, jsonFormsProps = __rest(_a, ["renderers"]);
    return (jsx(JsonForms$1, __assign({ renderers: __spreadArray([
            {
                renderer: JsonFormsAnyOfControl,
                tester: jsonFormsAnyOfControlTester,
            },
            {
                renderer: JsonFormsNullControl,
                tester: jsonFormsNullControlTester,
            },
            {
                renderer: JsonFormsOneOfEnumControl,
                tester: jsonFormsOneOfEnumControlTester,
            },
            {
                renderer: JsonFormsStringControl,
                tester: jsonFormsStringControlTester,
            },
            {
                renderer: JsonFormsHorizontalLayout,
                tester: jsonFormsHorizontalLayoutTester,
            },
            {
                renderer: JsonFormsVerticalLayout,
                tester: jsonFormsVerticalLayoutTester,
            },
            {
                renderer: JsonFormsGroupLayout,
                tester: JsonFormsGroupLayoutTester,
            },
            {
                renderer: JsonFormsBooleanControl,
                tester: jsonFormsBooleanControlTester,
            }
        ], renderers, true) }, jsonFormsProps), void 0));
};

export { JsonForms as J };
